import Decimal from 'decimal.js';

export const sum = (...numbers) => {
    return Decimal.sum(...numbers)
}
